import Repository from "@/utils/API/Repository";

export const resource = '/restaurants';

export default {
  updateRestaurantBrandingLogo(logoImageBase64: string) {
    return Repository.post(
      `${resource}/UpdateRestaurantBranding`,
      { brandImageBase64: logoImageBase64 },
      { withCredentials: true }
    );
  }
};
